/**
 * Copyright (C) 2021 Tencent.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default {
  bold: '加粗', // 加粗
  code: '代码', // 代码
  graph: '画图', // 画图
  h1: '一级标题', // 一级标题
  h2: '二级标题', // 二级标题
  h3: '三级标题', // 三级标题
  h4: '四级标题', // 四级标题
  h5: '五级标题', // 五级标题
  header: '标题', // 标题
  insert: '插入', // 插入
  italic: '斜体', // 斜体
  list: '列表', // 列表
  quickTable: '表格', // 表格
  quote: '引用', // 引用
  size: '大小', // 大小
  color: '文字颜色&背景', // 文字颜色&背景
  strikethrough: '删除线', // 删除线
  sub: '下标', // 下标
  sup: '上标', // 上标
  togglePreview: '预览', // 预览
  fullScreen: '全屏', // 全屏
  image: '图片', // 图片
  audio: '音频', // 音频
  video: '视频', // 视频
  link: '超链接', // 超链接
  hr: '分隔线', // 分隔线
  br: '换行', // 换行
  toc: '目录', // 目录
  pdf: 'pdf', // pdf
  word: 'word', // word
  table: '表格', // 表格
  'line-table': '折线表格', // 折线表格
  'bar-table': '柱状表格', // 柱状表格
  'radar-table': '雷达表格', // 雷达表格
  'map-table': '地图表格', // 地图表格
  lineTable: '折线图', // 折线表格
  barTable: '柱状图', // 柱状表格
  radarTable: '雷达图', // 雷达表格
  mapTable: '地图', // 地图表格
  heatmapTable: '热力图', // 热力图表格
  sankeyTable: '桑基图', // 桑基图表格
  pieTable: '饼图', // 饼图表格
  proTable: '图表', // 图表表格
  formula: '公式', // 公式
  insertFormula: '公式', // 公式
  insertFlow: '流程图', // 流程图
  insertSeq: '时序图', // 时序图
  insertState: '状态图', // 状态图
  insertClass: '类图', // 类图
  insertPie: '饼图', // 饼图
  scatterTable: '散点图', // 散点图
  insertGantt: '甘特图', // 甘特图
  checklist: '清单', // 清单
  ol: '有序列表', // 有序列表
  ul: '无序列表', // 无序列表
  undo: '撤销', // 撤销
  redo: '恢复', // 恢复
  previewClose: '关闭预览', // 关闭预览
  codeTheme: '代码主题', // 代码主题
  switchModel: '模式切换', // 模式切换
  switchPreview: '预览', // 预览
  switchEdit: '返回编辑', // 返回编辑
  classicBr: '经典换行', // 经典换行
  normalBr: '常规换行', // 常规换行
  settings: '设置', // 设置
  mobilePreview: '移动端预览', // 移动端预览
  copy: '复制内容', // 复制内容
  export: '导出', // 导出PDF、长图
  underline: '下划线', // 下划线
  pinyin: '拼音', // 拼音
  file: '文件',
  pastePlain: '粘贴为纯文本格式', // 粘贴为纯文本格式
  pasteMarkdown: '粘贴为markdown格式', // 粘贴为markdown格式
  hide: '隐藏工具栏', // 隐藏
  exportToPdf: '导出PDF', // 导出PDF
  exportScreenshot: '导出长图', // 导出长图
  exportMarkdownFile: '导出markdown', // 导出markdown文件
  exportHTMLFile: '导出html', // 导出预览区html文件
  exportWordFile: '导出word', // 导出Word文件
  theme: '主题', // 导出长图
  panel: '面板', // 导出长图
  detail: '手风琴', // 手风琴
  heading1: '一级标题',
  heading2: '二级标题',
  heading3: '三级标题',
  complement: '续写',
  summary: '总结',
  justify: '对齐方式',
  justifyLeft: '左对齐',
  justifyCenter: '居中',
  justifyRight: '右对齐',
  align: '对齐方式',
  alignLeft: '左对齐',
  alignCenter: '居中',
  alignRight: '右对齐',
  alignJustify: '两端对齐',
  alignFloatLeft: '左浮动',
  alignFloatRight: '右浮动',
  publish: '发布',
  colorPickerText: '文字',
  colorPickerBackground: '背景',
  colorPickerClear: '清除颜色',
  colorPickerRecentColors: '最近使用颜色',
  colorPickerPresetColors: '系统预设颜色',
  small: '小',
  medium: '中',
  large: '大',
  superLarge: '特大',
  detailDefaultContent: '点击展开更多\n内容\n++- 默认展开\n内容\n++ 默认收起\n内容',
  inlineCode: '行内代码',
  codeBlock: '代码块',
  inlineMath: '行内公式',
  mathBlock: '块级公式',
  shortcutKeySetting: '快捷键设置',
  editShortcutKeyConfigTip: '双击快捷键区域或点击编辑按钮编辑快捷键',
  editingShortcutKeyConfigTip: '按Enter键保存，Backspace键移除新增的键',
  staticShortcutTip: '内置快捷键不可修改',
  disabledShortcutTip: '当前快捷键已禁用',
  wordCount: '字数统计',
  wordCountP: '段落',
  wordCountW: '单词',
  wordCountC: '字符',
  deleteColumn: '删除列',
  deleteRow: '删除行',
  addRow: '添加行',
  addCol: '添加列',
  moveRow: '移动行',
  moveCol: '移动列',
  shortcutStaticTitle: '以下快捷键无法修改',
  shortcutStatic1: '整行向左缩进',
  shortcutStatic2: '整行向右缩进',
  shortcutStatic3: '复制并粘贴一行',
  shortcutStatic4: '在下方插入空行',
  shortcutStatic5: '在上方插入空行',
  shortcutStatic6: '与上行互换',
  shortcutStatic7: '与下行互换',
  shortcutStatic8: '删除一行',
  shortcutStatic9: '按词语向左选中',
  shortcutStatic10: '按词语向右选中',
  shortcutStatic11: '按词语删除',
  shortcutStatic12: '选中括号内内容',
  shortcutStatic13: '插入多个光标',
  shortcutStatic14: '分别选中文本块的每一行',
  shortcutStatic15: '查找',
  shortcutStatic16: '选中所有相同的词',
  shortcutStatic17: '撤销',
  shortcutStatic18: '回滚撤销',
  leftMouseButton: '鼠标左键',
  disableShortcut: '禁用所有快捷键',
  enableShortcut: '取消禁用快捷键',
  recoverShortcut: '恢复默认配置',
  search: '搜索',
  autoWrap: '自动换行',
  footnoteTitle: '脚注',
  searchFor: '查找',
  replaceWith: '替换为',
  previousMatch: '查找上一个',
  nextMatch: '查找下一个',
  replace: '替换',
  replaceAll: '全部替换',
  regExpSearch: '正则表达式搜索',
  caseSensitiveSearch: '区分大小写搜索',
  wholeWordSearch: '全字匹配搜索',
  matchesFoundText: '处匹配',
  toggleReplace: '展开/收起替换框',
  close: '关闭',
  border: '边框',
  shadow: '阴影',
  radius: '圆角',
  customShortcut: '自定义快捷键',
  staticShortcut: '内置快捷键',
  edit: '编辑',
  save: '保存',
  cancel: '取消',
  saveAsImage: '保存为图片',
  mapChartLoading: '正在加载地图数据',
  mapChartLoadingTip: '如果长时间未显示，请检查网络连接',
  mapChartError: '地图数据加载失败',
  mapChartErrorTip: '请检查数据源或网络链接',
  mapChartRetry: '点击重新加载',
  chartRenderError: '图表渲染失败',
  chartLibraryNotLoadedTip: 'ECharts 图表库未加载',
  radarData: '雷达图数据',
  scatterData: '散点数据',
  pieData: '数据分布',
  heatmapData: '热力图数据',
  mapData: '地图数据',
  maxValue: '最大值',
  minValue: '最小值',
  high: '高',
  low: '低',
};
